export const isStepDone = (completions, stepId) => {
  const entry = completions ? completions[stepId] : null
  if (!entry) return false
  return typeof entry === 'object' ? !!entry.done : !!entry
}

export const isStepSkipped = (completions, stepId) => {
  const entry = completions ? completions[stepId] : null
  return !!(entry && typeof entry === 'object' && entry.skipped)
}

export const isStepSatisfied = (completions, stepId) => {
  return isStepDone(completions, stepId) || isStepSkipped(completions, stepId)
}

export const isProductLocked = (step, lockedProducts) => {
  return !!(step?.product && lockedProducts?.[step.product])
}

export const isStepLocked = (completions, step, unavailableStepIds = []) => {
  const requires = step?.requires || []
  return requires.some(stepId => !unavailableStepIds.includes(stepId) && !isStepSatisfied(completions, stepId))
}

export const computeProgress = (completions, steps) => {
  let pointsDone = 0
  let pointsTotal = 0
  let stepsDone = 0
  const bySection = {}

  steps.forEach(step => {
    const weight = step.weight || 1
    const done = isStepSatisfied(completions, step.id)

    pointsTotal += weight
    if (done) {
      pointsDone += weight
      stepsDone++
    }

    if (!bySection[step.section]) bySection[step.section] = { done: 0, total: 0, complete: false }
    bySection[step.section].total++
    if (done) bySection[step.section].done++
  })

  Object.values(bySection).forEach(section => {
    section.complete = section.total > 0 && section.done === section.total
  })

  return {
    percent: pointsTotal === 0 ? 0 : Math.round((pointsDone / pointsTotal) * 100),
    pointsDone,
    pointsTotal,
    stepsDone,
    stepsTotal: steps.length,
    bySection
  }
}
